import { Grid, Tab, Tabs, useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import PageTab from 'components/tabs/PageTab'
import { getTitle } from 'components/tabs/TabsTitle'
import { useCheckAuthorizationAndRedirect } from 'hooks/useCheckAuthorizationAndRedirect'
import { useTabsControl } from 'hooks/useTabsControl'
import React from 'react'
import { UserType } from 'types'
import { SharedSentTab } from '../SharedSentTab/SharedSentTab'
import { SharedTimelineTab } from '../SharedTimelineTab/SharedTimelineTab'

export function SharedPage() {
  const theme = useTheme()
  const matchesMd = useMediaQuery(theme.breakpoints.down('lg'))
  const { selectedTab, handleChangeSelectedTab } = useTabsControl<string>('first')

  const redirect = useCheckAuthorizationAndRedirect([UserType.TRAINEE, UserType.CAREGIVER])

  const firstTabTitle = 'Received'
  const secondTabText = 'Sent'

  if (redirect) {
    return <>{redirect}</>
  }

  const firstTab = <SharedTimelineTab />
  const secondTab = <SharedSentTab />

  if (matchesMd) {
    return (
      <>
        <Tabs
          value={selectedTab}
          onChange={handleChangeSelectedTab}
          color="secondary"
          indicatorColor="secondary"
          textColor="secondary"
          variant="fullWidth"
          sx={{ background: 'white' }}
        >
          <Tab value="first" label={getTitle(firstTabTitle, undefined)} />
          <Tab value="second" label={getTitle(secondTabText, undefined)} />
        </Tabs>

        {selectedTab === 'first' && firstTab}
        {selectedTab === 'second' && secondTab}
      </>
    )
  }

  return (
    <Grid container spacing={1} flexGrow={1}>
      <Grid item sm={12} md={6} lg={6} display="flex" flexDirection="column">
        <PageTab title={firstTabTitle} />
        {firstTab}
      </Grid>

      <Grid item sm={12} md={6} lg={6} display="flex" flexDirection="column">
        <PageTab title={secondTabText} />
        {secondTab}
      </Grid>
    </Grid>
  )
}
